import { apiConfig } from '@/services/api-config';

export default async function () {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
  const tokenKey = userLogged.company.stKey;
  const document = userLogged.stDocument;

  return apiConfig
    .put(`api/TerritoryAccess/${document}/update-voucher?tokenKey=${tokenKey}`)
    .then((response) => response.data.objectResult)
    .catch((err) => ({ hasErros: true, message: err.message }));
}
